import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class SavedSearchService {
  private filterCache = new Map<string, any>();

  constructor(private apiService: ApiService) {}

  async fetchColumnState(data: any) {
    return lastValueFrom(this.apiService.get('customer/column-state', data, true));
  }

  async updateColumnState(data: any) {
    return lastValueFrom(this.apiService.post('customer/column-state', data, true));
  }

  fetchColumnStateViewFilter(type: string) {
    return lastValueFrom(this.apiService.get(`customer/get-column-state?type=${type}`, {}, true));
  }

  async fetchViewFilterList(type: string, forceRefresh: boolean = false) {
    if (!forceRefresh && this.filterCache.has(type)) {
      return this.filterCache.get(type);
    }
    const res = await lastValueFrom(this.apiService.get(`customer/view-filter?type=${type}`, {}, true));
    this.filterCache.set(type, res);
    return res;
  }

  async saveViewFilter(data: any) {
    const res = await lastValueFrom(this.apiService.post('customer/view-filter', data, true));
    this.filterCache.delete(data.type);
    return res;
  }

  async updateViewFilter(id: any, data: any) {
    const res = await lastValueFrom(this.apiService.post(`customer/view-filter/${id}`, data, true));
    this.filterCache.delete(data.type);
    return res;
  }

  async deleteViewFilter(id: string, data: any) {
    const res = await lastValueFrom(this.apiService.delete(`customer/view-filter/${id}`, data, true));
    this.filterCache.delete(data.type);
    return res;
  }
}
